import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AlertDialogComponent } from 'src/app/store/dialogs/alert-dialog/alert-dialog.component';
import { AccountRole } from 'src/app/model/account-role';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TbAuthService } from '@tb/auth';
import { UserServices } from './user.services';

@Injectable({
    providedIn: 'root',
})
export class WorkFlowService {
    industriesServiceURL: string;
    authorizationStored;
    authorizationProperties: AuthorizationProperties;
    accountRoles: Array<AccountRole>;
    obj = {};
    language: string;

    constructor(
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private authService: TbAuthService,
        private userService: UserServices
    ) {
        this.industriesServiceURL = environment.settings.industriesServiceUrl;
        this.accountRoles = new Array<AccountRole>();
    }

    showMessage(Title: string, Message: string, ImagePath?: string) {
        // this.snackBar.open(
        //     `${Title}, ${Message}`,
        //     'OK',
        //     { duration: 5000 }
        // );
        this.dialog.open(AlertDialogComponent, {
            data: {
                Title,
                Message,
                ImagePath
            },
        });
    }

    showSnackBar(Title: string, Message?: string) {
        if (Message) {
            this.snackBar.open(
                `${Title}, ${Message}`,
                'OK',
                //tolta durata snackBar temporaneamente
                // { duration: 5000 }
            );
        }
        else {
            this.snackBar.open(
                `${Title}`,
                'OK',
                //tolta durata snackBar temporaneamente
                // { duration: 5000 }
            );
        }
    }

    comeBack() {
        window.history.back();
    }

    languageIsItalian(): boolean {
        if (this.authService.isSessionStorage()) {
            this.language = sessionStorage.getItem('selectedLanguage');
        } else {
            this.language = localStorage.getItem('selectedLanguage');
        }
        if (this.language) {
            if (this.language.toLowerCase() === "it-it") {
                return true;
            }
            else {
                return false;
            }
        }
        else if (this.userService.getUserLanguage().toLowerCase() === "it-it") {
            return true;
        }
        else {
            return false;
        }
    }

    getLanguageForCms(): string {
        let language: string;
        if (this.authService.isSessionStorage()) {
            language = sessionStorage.getItem('selectedLanguage');
        } else {
            language = localStorage.getItem('selectedLanguage');
        }
        if (!language || (language !== "it-IT" && language !== "en-US" && language !== "de-DE")) {
            let lang = this.userService.getUserLanguage().substr(0, 2).toLowerCase();
            if (lang === 'it') {
                language = "it-IT";
            }
            else if (lang === 'de') {
                language = "de-DE";
            }
            else {
                language = "en-US";
            }
        }
        return language;
    }


}
